import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = {
  class: "relative z-10 flex flex-col items-center justify-center"
};
const _hoisted_2 = {
  class: "loader-visual relative w-48 h-48 mb-6"
};
const _hoisted_3 = {
  class: "w-full h-full animate-spin-slow",
  viewBox: "0 0 200 200",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_4 = ["stroke"];
const _hoisted_5 = ["stroke"];
const _hoisted_6 = ["stroke"];
const _hoisted_7 = {
  class: "text-center space-y-2"
};
const _hoisted_8 = {
  class: "loading-text text-sm font-bold tracking-[0.3em] uppercase animate-pulse"
};
import { computed } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'GEOLoading',
  props: {
    theme: {
      default: 'light'
    },
    text: {
      default: 'SYSTEM INITIALIZING...'
    }
  },
  setup(__props) {
    const props = __props;
    // 计算容器类名
    const containerClasses = computed(() => {
      return ['geo-loader-fixed', props.theme === 'dark' ? 'theme-dark' : 'theme-light'];
    });
    // 计算主色调 (用于 SVG stroke 引用)
    const strokeColorUrl = computed(() => {
      return props.theme === 'dark' ? 'url(#gradDark)' : 'url(#gradLight)';
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(containerClasses.value)
      }, [_cache[4] || (_cache[4] = _createElementVNode("div", {
        class: "bg-grid-pattern absolute inset-0 opacity-10 pointer-events-none"
      }, null, -1)), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[1] || (_cache[1] = _createElementVNode("div", {
        class: "absolute inset-0 flex items-center justify-center z-20"
      }, [_createElementVNode("h1", {
        class: "geo-text text-4xl font-black tracking-widest select-none"
      }, "GEO")], -1)), (_openBlock(), _createElementBlock("svg", _hoisted_3, [_cache[0] || (_cache[0] = _createStaticVNode("<defs data-v-ec843c46><linearGradient id=\"gradLight\" x1=\"0%\" y1=\"0%\" x2=\"100%\" y2=\"100%\" data-v-ec843c46><stop offset=\"0%\" stop-color=\"#3b82f6\" data-v-ec843c46></stop><stop offset=\"100%\" stop-color=\"#8b5cf6\" data-v-ec843c46></stop></linearGradient><linearGradient id=\"gradDark\" x1=\"0%\" y1=\"0%\" x2=\"100%\" y2=\"0%\" data-v-ec843c46><stop offset=\"0%\" stop-color=\"#06b6d4\" data-v-ec843c46></stop><stop offset=\"100%\" stop-color=\"#22d3ee\" data-v-ec843c46></stop></linearGradient><filter id=\"glow\" x=\"-50%\" y=\"-50%\" width=\"200%\" height=\"200%\" data-v-ec843c46><feGaussianBlur stdDeviation=\"4\" result=\"coloredBlur\" data-v-ec843c46></feGaussianBlur><feMerge data-v-ec843c46><feMergeNode in=\"coloredBlur\" data-v-ec843c46></feMergeNode><feMergeNode in=\"SourceGraphic\" data-v-ec843c46></feMergeNode></feMerge></filter></defs>", 1)), _createElementVNode("circle", {
        cx: "100",
        cy: "100",
        r: "90",
        stroke: strokeColorUrl.value,
        "stroke-width": "2",
        "stroke-linecap": "round",
        class: "circle-ring ring-outer"
      }, null, 8, _hoisted_4), _createElementVNode("circle", {
        cx: "100",
        cy: "100",
        r: "70",
        stroke: strokeColorUrl.value,
        "stroke-width": "4",
        "stroke-opacity": "0.3",
        class: "circle-ring ring-inner"
      }, null, 8, _hoisted_5), _createElementVNode("circle", {
        cx: "100",
        cy: "100",
        r: "70",
        stroke: strokeColorUrl.value,
        "stroke-width": "4",
        "stroke-linecap": "round",
        "stroke-dasharray": "100 340",
        class: "circle-ring ring-scanner"
      }, null, 8, _hoisted_6)])), _cache[2] || (_cache[2] = _createElementVNode("div", {
        class: "absolute inset-0 border border-current rounded-full opacity-20 scale-50 animate-pulse"
      }, null, -1))]), _createElementVNode("div", _hoisted_7, [_createElementVNode("p", _hoisted_8, _toDisplayString(__props.text), 1), _cache[3] || (_cache[3] = _createElementVNode("div", {
        class: "w-32 h-1 bg-gray-200/20 rounded-full overflow-hidden mx-auto"
      }, [_createElementVNode("div", {
        class: "h-full w-1/2 bg-current animate-progress-indeterminate"
      })], -1))])])], 2);
    };
  }
});